import React from 'react';
interface SupplyTagProps {
  label?: string;
  tone?: 'light' | 'dark';
}

// Marks content that must be supplied by AFB before launch.
export function SupplyTag({
  label = 'Client to supply',
  tone = 'light'
}: SupplyTagProps) {
  const styles = tone === 'light' ? 'border-afb-ink/15 bg-afb-light text-afb-muted' : 'border-white/15 bg-white/[0.04] text-white/60';
  return <span className={`inline-flex items-center gap-1.5 rounded-md border border-dashed px-2 py-0.5 text-[11px] font-medium ${styles}`} data-id="element-561" data-mp="2oyk4dn1zdtc4">
      <span className="h-1.5 w-1.5 rounded-full bg-afb-yellow" aria-hidden="true" data-id="element-562" data-mp="2k08r12ch90p5" />
      {label}
    </span>;
}